import { render } from "./AppSlider.vue?vue&type=template&id=770a6200&scoped=true&ts=true"
import script from "./AppSlider.vue?vue&type=script&lang=ts"
export * from "./AppSlider.vue?vue&type=script&lang=ts"

import "./AppSlider.vue?vue&type=style&index=0&id=770a6200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770a6200"]])

export default __exports__